
import { memo, useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzButton } from '../../components';
import { getAppInfoData, getDyanmicURL, getFormattedNumbers } from '../../utils/global_functions';
import { APP_AVG_BUY_PRICE, APP_INFO_DEFAULT_VALUES, APP_INFO_PARAMS, LINK_OPEN_MODES } from '../../utils/global_variables';
import { updateInAppIFrame } from '../../redux/actions/appInfo';
import { handleModal } from '../../redux/actions/modals';

const Summary = ({ objChartConfig, chartData, objPortfolioSumaary, ...props }) => {
    const appInfo = useSelector(state => state.appInfo.appInfo);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const dispatch = useDispatch();
    const isInvestedOverallPLVisible = useMemo(() => {
        const isVisible = getAppInfoData(APP_INFO_PARAMS.APP_AVG_BUY_PRICE, APP_AVG_BUY_PRICE.OFF);
        if (isVisible === APP_AVG_BUY_PRICE.OFF) {
            return true;
        } else if (isVisible === APP_AVG_BUY_PRICE.ON) {
            return false;
        }
    }, [appInfo]);
    // Vaibhav Singh: BT-107421: 06-02-24: Corrected earlier correct cases  related to portfolio page: Start
    const portfolioAnalyzerUrl = useMemo(() => {
        const analyzerData = getAppInfoData(APP_INFO_PARAMS.APP_PORTFOLIO_ANALYZER, APP_INFO_DEFAULT_VALUES.PORTFOLIO_ANALYZER_DATA);
        return analyzerData;
    }, [appInfo]);
    const handlePortfolioAnalyser = () => {
        const URL = getDyanmicURL({ url: portfolioAnalyzerUrl?.url }, objLoginSession);
        if (URL) {
            if (portfolioAnalyzerUrl?.openmode === LINK_OPEN_MODES.IFRAME) {
                dispatch(updateInAppIFrame({ url: URL, title: portfolioAnalyzerUrl?.title }));
                dispatch(handleModal([{ "IN_APP_IFRAME": true }]));
            }
            else {
                window.open(portfolioAnalyzerUrl?.url);
            }
        } else { }

    };
    // Vaibhav Singh: BT-107421: 06-02-24: Corrected earlier correct cases  related to portfolio page: End
    return (
        <Container fluid {...props} className='p-0 p-3'>
            <div className='funds-card-wrapper bdr-radius-10 p-3' data-testid="portfolio-summary-card">
                <Row className='g-0'>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='icon-16 icon-portfolio icon-dark me-1'></div>
                        <div data-testid="portfolio-summary-heading" className='font-medium font-size6 color-text text-uppercase'>SUMMARY</div>
                    </Col>
                </Row>
                <Row className='g-0 pt-3 align-items-center'>
                    <Col>
                        <div className='font-regular font-size2 color-subtext text-capitalize'>Current Value</div>
                        <div data-testid="portfolio-summary-current-value" className={`font-medium font-size6 text-nowrap color-text ${parseFloat(objPortfolioSumaary?.currentValue) === 0 ? '' : objPortfolioSumaary?.currentValue > 0 ? 'color-positive' : 'color-negative'}`}>&#8377;{getFormattedNumbers(objPortfolioSumaary?.currentValue)}</div>
                    </Col>
                    {isInvestedOverallPLVisible && <Col>
                        <div className='font-regular font-size2 color-subtext text-capitalize'>Invested</div>
                        <div data-testid="portfolio-summary-invested-value" className='font-medium font-size6 text-nowrap color-text'>&#8377;{getFormattedNumbers(objPortfolioSumaary?.investedValue)}</div>
                    </Col>}
                    <Col>
                        <div data-testid="portfolio-summary-todays-pl-label" className='font-regular font-size2 color-subtext text-capitalize'>Today's P/L</div>
                        <div data-testid="portfolio-summary-todays-pl-value" className={`font-regular font-size5 text-nowrap color-text ${parseFloat(objPortfolioSumaary?.todaysPL) === 0 ? '' : objPortfolioSumaary?.todaysPL > 0 ? 'color-positive' : 'color-negative'}`}>&#8377;{getFormattedNumbers(objPortfolioSumaary?.todaysPL)}
                            {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA  Todays and OverAll P/l % removed -Start
                                         Dont remove code it may be require later  */}
                            {/* ( {getFormattedNumbers(objPortfolioSumaary?.todaysPLPer)} % ) */}
                            {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA  Todays and OverAll P/l % removed -End */}
                        </div>
                    </Col>
                    {isInvestedOverallPLVisible && <Col>
                        <div data-testid="portfolio-summary-overall-pl-label" className='font-regular font-size2 color-subtext text-capitalize'>Overall P/L</div>
                        <div data-testid="portfolio-summary-overall-pl-value" className={`font-regular font-size5 text-nowrap color-text ${parseFloat(objPortfolioSumaary?.todaysPL) === 0 ? '' : objPortfolioSumaary?.overAllPL > 0 ? 'color-positive' : 'color-negative'}`}>&#8377;{getFormattedNumbers(objPortfolioSumaary?.overAllPL)}
                            {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA  Todays and OverAll P/l % removed -Start
                                         Dont remove code it may be require later  */}
                            {/* ( {getFormattedNumbers(objPortfolioSumaary?.PLPer)} %) */}
                            {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA  Todays and OverAll P/l % removed -End */}
                        </div>
                    </Col>}
                </Row>
                {/*Vaibhav Singh: BT-107421: 06-02-24: Corrected earlier correct cases  related to portfolio page: Start */}
                {
                    portfolioAnalyzerUrl && portfolioAnalyzerUrl?.url &&
                    <Row className='g-0 mt-3'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <BzButton data-testid="portfolio-analyzer-button" className='btn btn-sm btn-primary' onClick={handlePortfolioAnalyser}>{portfolioAnalyzerUrl?.title}</BzButton>
                        </Col>
                    </Row>
                }
                {/*Vaibhav Singh: BT-107421: 06-02-24: Corrected earlier correct cases  related to portfolio page: End */}
            </div>
        </Container>

    );
};

export default memo(Summary);